import {
  CLEAR_SUPPLIER_SECRETS,
  GET_SUPPLIER_SECRETS_FAILED,
  GET_SUPPLIER_SECRETS_REQUESTED,
  GET_SUPPLIER_SECRETS_SUCCESS,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const supplierSecretsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUPPLIER_SECRETS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUPPLIER_SECRETS_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_SUPPLIER_SECRETS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_SUPPLIER_SECRETS:
      return initialState;
    default:
      return state;
  }
};

export default supplierSecretsReducer;
